import { useMemo } from "react";

import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";

import { type User } from "@internal/user";
import { Select } from "@shared/selects";
import { usePrefs } from "@utils/client-side-preferences";

type ImpersonateClientSelectModel = {
  id: string;
  email: string;
  isAdmin: boolean;
  companyName: string | null;
};

interface Props {
  readonly user: User;
  data: ImpersonateClientSelectModel[];
  inputClassName?: string;
}

export const ImpersonateClientSelect = ({ user, ...props }: Props) => {
  const navigate = useNavigate();

  const prefs = usePrefs();

  const value = useMemo(
    () =>
      props.data.find((d) =>
        [user?.impersonatedUser?.id, user.displayUserId].includes(d.id),
      ),
    [user, props.data],
  );

  const location = useLocation();

  const selectOptions = props.data.map((i) => ({
    value: i,
    label: prefs.isDemoMode ? "Widgets Co" : i.companyName ?? "",
  }));

  return (
    <Select<ImpersonateClientSelectModel | undefined>
      className={clsx(
        props.inputClassName,
        "border-transparent rounded-md text-primary",
        "focus:bg-cosmic-4 hover:bg-cosmic-4 focus:ring-0 ",
      )}
      activeInputClassName="bg-cosmic-4"
      isSearchable
      value={value}
      options={selectOptions}
      onChange={(v) => {
        if (v) {
          const pathname = location.pathname.slice(1);
          const excludingUserIdPath = pathname.substring(
            pathname.indexOf("/") + 1,
          );
          navigate(
            `/${v.id}${excludingUserIdPath ? `/${excludingUserIdPath}` : ""}`,
          );
          window.location.reload();
        }
      }}
    />
  );
};
